<app-document-countries
  [name]="'Договор аренды'"
  [countries]="countries"
></app-document-countries>
